import React from 'react';
import { FadeIn } from '../FadeIn';
export function ProblemSolutionAHA() {
  return <section className="py-20 md:py-28 bg-white overflow-hidden" data-id="element-247">
      <div className="max-w-[900px] mx-auto px-6 md:px-8" data-id="element-248">
        <FadeIn data-id="element-249">
          <div className="bg-ivory border border-gold/40 rounded-[32px] p-8 md:p-12 lg:p-16 shadow-xl relative overflow-hidden" data-id="element-250">
            <div className="absolute top-0 right-0 w-64 h-64 bg-forest/5 rounded-full blur-3xl -z-10" data-id="element-251"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-gold/10 rounded-full blur-2xl -z-10" data-id="element-252"></div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-forest mb-10 text-center leading-tight" data-id="element-253">
              Știi senzația când valul vine și nu mai ai cuvinte?
            </h2>

            <div className="space-y-6 text-charcoal/80 font-sans text-[19px] leading-relaxed" data-id="element-254">
              <p data-id="element-255">
                Te trezești dimineața cu un nod în piept și nu știi de unde
                vine. Un email te scoate din ritm pentru tot restul zilei.
                Plângi pe ascuns în baie și apoi te întorci la întâlnire ca și
                cum nimic nu s-ar fi întâmplat. Sau invers, nu mai simți nimic
                și te întrebi dacă ești bine.
              </p>

              <p data-id="element-256">
                Dacă lași valurile astea să se adune, corpul începe să poarte ce
                nu spui. Apar insomnii, tensiune permanentă, izbucniri la oameni
                care nu au nicio vină. Și cel mai greu, începi să crezi că ești{' '}
                <span className="font-serif italic text-forest text-xl" data-id="element-257">
                  exagerată
                </span>
                . Că ceilalți fac față mai bine. Că trebuie doar să taci și să
                continui.
              </p>

              <div className="mt-10 pt-8 border-t border-gold/30" data-id="element-258">
                <p className="font-medium text-forest" data-id="element-259">
                  Acest mini-curs îți dă un set de instrumente simple pe care le
                  poți folosi oriunde și oricând: pe birou, în mașină, la două
                  noaptea când nu poți să dormi.
                </p>
                <p className="mt-4" data-id="element-260">
                  Cinci audio-uri ghidate, un workbook PDF, trei tehnici de
                  respirație și o fișă pe care o completezi când ești calmă ca
                  să o folosești când nu ești. Nu îți promit că nu vei mai simți
                  durere. Îți promit că{' '}
                  <span className="font-serif italic text-forest text-xl" data-id="element-261">
                    nu vei mai fi singură cu ea
                  </span>
                  .
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}